import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledPath = styled.path`
  fill: ${(p) => p.theme.colors.oceanBlue};
`
const SpreadIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 64.03 56.551">
    <g transform="translate(-5 -10.256)">
      <StyledPath
        d="M68.728 76.486l-10.044-20.1a1.51 1.51 0 0 0-.872-.753l-10.159-3.39a1.541 1.541 0 0 0-.963 0L37 55.469l-9.7-3.232a1.534 1.534 0 0 0-.944 0L16.2 55.628a1.536 1.536 0 0 0-.876.757L5.156 76.718A1.511 1.511 0 0 0 6.51 78.9a1.483 1.483 0 0 0 .611-.131l14.633-6.5 14.635 6.506a1.53 1.53 0 0 0 1.224 0l14.634-6.5 14.629 6.5a1.545 1.545 0 0 0 .647.132 1.515 1.515 0 0 0 1.5-1.51 1.49 1.49 0 0 0-.295-.911zm-47.682-5.725l-14.21 6.316 9.947-19.89 8.866-2.955zm15.122 6.092l-13.429-5.969 4.692-16.85 8.737 2.913v19.906zm1.665 0V56.947l8.76-2.92 4.664 16.859zm15.112-6.1l-4.57-16.517 8.852 2.95 9.937 19.888z"
        transform="translate(0 -12.093)"
      />
      <StyledPath
        d="M47.993 28.623a4.9 4.9 0 1 0-4.9-4.9 4.9 4.9 0 0 0 4.9 4.9zm0-8.132a3.234 3.234 0 1 1-3.234 3.234 3.237 3.237 0 0 1 3.234-3.234z"
        transform="translate(-10.992 -2.474)"
      />
      <StyledPath
        d="M44.808 39.977a.832.832 0 0 0 1.425 0c2.067-3.438 3.945-6.111 5.453-8.259 2.91-4.144 4.831-6.882 4.831-10.466a11 11 0 1 0-21.992 0c0 3.584 1.922 6.322 4.831 10.465 1.507 2.148 3.383 4.821 5.452 8.26zm.712-28.057a9.343 9.343 0 0 1 9.333 9.332c0 3.058-1.7 5.487-4.53 9.511-1.348 1.921-2.987 4.257-4.8 7.188-1.816-2.931-3.455-5.268-4.8-7.189-2.824-4.023-4.529-6.451-4.529-9.51a9.342 9.342 0 0 1 9.326-9.332z"
        transform="translate(-8.519)"
      />
    </g>
  </SvgIcon>
)

export default SpreadIcon
